import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable()
export class UserService {
  
  constructor(private http: HttpClient) {
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }

  /**
   * Service to retrieve Organism list.
   * @returns Returns a list of Organism.
   */
  getProfile(): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/profile').
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getPrivilages(): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/privilages').
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getMenus(): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/menuList').
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getMenusByUser(): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/menuList/'+localStorage.getItem(CommonConstants.USER_SUB_PROFILE)).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  /**
   * Service to retrieve Organism list.
   * @returns Returns a list of Organism.
   */
  getApplications(): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/application').
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getUserDetailsById(userId:number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/'+userId).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
    
    
  searchUser(userSearch){
    return this.http.post(CommonConstants.USER_SERCH, userSearch).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

/**
   * Service to retrieve Organism object for organism id.
   * @param organism id
   * @returns Returns Organism Object.
   */
  getSubProfileByProfileId(profileId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/user/subProfile/' + profileId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveUser(saveData): Observable<any> {
    return this.http.post(CommonConstants.CREATE_USER, saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveSubProfile(saveData): Observable<any> {
    return this.http.post(CommonConstants.CREATE_SUB_PROFILE, saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  errorHandler(error: any): void {
    throwError(error);
  };
  isAuthenticated(): boolean {
    return !!localStorage.getItem(CommonConstants.ACCESS_TOKEN);
}
mapProfilePrivilage(userPrvilages: any[]) {
  return this.http.post(CommonConstants.MAP_PROFILE_PRIVILAGE, userPrvilages).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
}
changePassword(data:any){
  return this.http.post(CommonConstants.CHANGE_PASSWORD,data).
  pipe(catchError((e: any) => throwError(this.errorHandler(e))));
}
mapProfileMenu(userMenus: any[]) {
  return this.http.post(CommonConstants.MAP_PROFILE_MENU, userMenus).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
}
getMenusBySubProfileId(secSubProId: any) {
  return this.http.get(CommonConstants.env + 'api/user/subprofile/menu/' + secSubProId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
}
getPrivilagesBySubProfileId(secSubProId: any) {
  return this.http.get(CommonConstants.env + 'api/user/subprofile/privilage/' + secSubProId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
}
getMenuList(): Array<any> {
  return JSON.parse(localStorage.getItem(CommonConstants.USER_MENUS));
}

}